import React from "react";
import TBGallery from "../../../photoGallery/TBGallery";
import Image1 from "../../../../assets/gallery/currentProjects/GiancarloCoco/1.webp";
import Image5 from "../../../../assets/gallery/currentProjects/GiancarloCoco/5.webp";
import Image6 from "../../../../assets/gallery/currentProjects/GiancarloCoco/6.webp";
import Image7 from "../../../../assets/gallery/currentProjects/GiancarloCoco/7.webp";
import Image8 from "../../../../assets/gallery/currentProjects/GiancarloCoco/8.webp";
import Image9 from "../../../../assets/gallery/currentProjects/GiancarloCoco/9.webp";
import { ProjectDetails } from "./ProjectDetails";
import "../../projectStyling/style.css"
import Footer from "../../../Footer";

const GiancarloCoco = () => {
  const galleryImages = [
    {
      img: Image1,
    },
    {
      img: Image5,
    },
    {
      img: Image6,
    },
    {
      img: Image7,
    },
    {
      img: Image8,
    },
    {
      img: Image9,
    },
  ];
  return (
    <>
      <br />
      <div>
        <ProjectDetails />
      </div>
      <br />
      <div>
        <TBGallery galleryImages={galleryImages} />
      </div>
      <div><Footer /></div>
    </>
  );
};

export default GiancarloCoco;
